import React, { useEffect, useState}  from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import IconoPrincipal from './IconoPrincipal';
import consultadeuda from "../assets/images/consultadeuda.png"; 
import geoportal from "../assets/images/geoportal.png";
import informeusodesuelo from "../assets/images/informeusodesuelo.png";
import lineafabrica from "../assets/images/lineafabrica.png";
import calculadora from "../assets/images/calculadora.png";
import { useHistory } from "react-router";

import background from "../assets/images/imagenPrincipalPadroVicente.png";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Cayambe
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
}));

function Home() {
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  let history = useHistory();
  const [showPage,setShowPage]=useState(false);
  useEffect(()=>{
    const redirectFromHash = () => {
      const {hash}=window.location;
      if(hash==="#/searching_value=mobile") history.push("/mobileportal");
      else  if(hash==="#/searching_value=mobile2") history.push("/geoportalv2");
      else  if(hash.startsWith("#/searching_value=deuda")) {
        const query = hash.replace("#/searching_value=deuda", "");
        history.replace(`/consulta_deuda${query}`);
      }
      else setShowPage(true);
    };

    redirectFromHash();
    window.addEventListener('hashchange', redirectFromHash);
    window.addEventListener('pageshow', redirectFromHash);

    return () => {
      window.removeEventListener('hashchange', redirectFromHash);
      window.removeEventListener('pageshow', redirectFromHash);
    };
  },[history]);
  return (
    showPage&&<main className={classes.content} style={{ backgroundImage:`url(${background})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center top",
    backgroundSize: "100% auto"
    }} >
    <div className={classes.root}>
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
          <Grid item xs={12}>
          <div style={{textAlign:"center"}}>
            
            </div>
            </Grid>


            <Grid item xs={12} md={4} lg={3}>
              <Paper className={fixedHeightPaper} onClick={()=>{history.push("/consulta_deuda")}}>
                <IconoPrincipal leyenda="Consulta de deudas" imagen={consultadeuda}/>
              </Paper>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <Paper className={fixedHeightPaper} onClick={()=>{
                history.push("/geoportal");
                //const win=window.open("/geoportal","_blank");
                //win.focus();
                }}>
                <IconoPrincipal leyenda="Geoportal" imagen={geoportal}/>
              </Paper>
            </Grid>
            {/*<Grid item xs={12} md={4} lg={3}>
              <Paper className={fixedHeightPaper} onClick={()=>{history.push("/linea_fabrica")}}>
                <IconoPrincipal leyenda="IPRUS" imagen={informeusodesuelo} />
              </Paper>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <Paper className={fixedHeightPaper} onClick={()=>{history.push("/compatibilidad_suelo")}}>
                <IconoPrincipal leyenda="Compatibilidad de uso de suelo" imagen={lineafabrica}/>
              </Paper>
            </Grid>*/}

            <Grid item xs={12} md={4} lg={3}>
              <Paper className={fixedHeightPaper} onClick={()=>{history.push("/calculator")}}>
                <IconoPrincipal leyenda="Calculadora de Plusvalía" imagen={calculadora}/>
              </Paper>
            </Grid>

          </Grid>
        </Container>
    </div>
    </main>
  );
}

export default Home;
